/**
 * Module System Entry Point
 *
 * Import this file to initialize the module registry.
 */

// Initialize the registry with all specs
import { initializeModuleRegistry } from './specs';

// Auto-initialize on import
initializeModuleRegistry();

// Re-export registry functions
export {
  moduleRegistry,
  registerModule,
  registerModules,
  getModuleById,
  getModuleByPath,
  getAllModules,
  getNavGroups,
  getBreadcrumbs,
  ModuleRegistrationError,
} from './registry';

// Re-export types
export type {
  ModuleSpec,
  ModulePermission,
  ModuleNavigation,
  ModuleI18n,
  ModuleMeta,
  NavItem,
  NavGroup,
  NavGroupId,
  ModuleStatus,
  Breadcrumb,
  BreadcrumbTrail,
  UserContext,
  FeatureFlagContext,
  PermissionAction,
  PermissionSubject,
} from './types';

export {
  NAV_GROUP_I18N_KEYS,
  NAV_GROUP_ORDER,
  isModuleSpec,
} from './types';
